// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__YmDW5","spin":"Spinner_spin__sJGno"};